class LoadMorePagination {

	constructor() {
		this.search();
	}

	search(){
		( function( $ ) {
			$('#load-more-pagination').on('click', function(e){
        if($('.page-numbers.next').length){

          $.ajax({
            type: 'GET',
            url: $('.page-numbers.next').attr('href'),
            data: { },
            success: function(data){
              $('#home-posts').append($(data).find('#home-posts').html())
              $('#load-more-pagination-div').html($(data).find('#load-more-pagination-div').html())

              if(!$(data).find('#load-more-pagination-div .page-numbers.next').length){
                $('#load-more-pagination').prop('disabled', true);
              }
            }
          });

        }else{
          $('#load-more-pagination').prop('disabled', true);
        }
			});
		}( jQuery ) );
	}
}

export default LoadMorePagination;
